import { getIcon } from '../../utils/categoryIcons';

export const CategorySidebar = ({ categories, activeCategory, onSelect, displayGroup }) => {
  const isGroupView = displayGroup !== null;
  
  return (
    <div className="category-sidebar bg-white border-r border-slate-200">
      {isGroupView && (
        <button
          onClick={() => onSelect(null)}
          className="category-btn touch-press bg-slate-100 border-slate-300 mb-2"
        >
          <span className="text-xs font-medium">All</span>
        </button>
      )}
      {categories.map((cat) => {
        const IconComponent = getIcon(cat.icon);
        const isActive = displayGroup 
          ? cat.display_group === displayGroup
          : activeCategory === cat.id;
        return (
          <button
            key={cat.id}
            data-testid={`category-${cat.name.toLowerCase().replace(/\s+/g, '-')}`}
            onClick={() => onSelect(cat.id)}
            className={`category-btn touch-press ${isActive ? 'active' : ''}`}
          >
            <IconComponent className="w-6 h-6" />
            <span className="text-xs font-medium text-center leading-tight">
              {cat.name}
            </span>
          </button>
        );
      })}
    </div>
  );
};
